import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "in-app-camera"
}
const _hoisted_2 = { class: "camera-header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_5 = ["fill"]
const _hoisted_6 = { class: "camera-video" }
const _hoisted_7 = {
  ref: "preview",
  autoplay: "",
  class: "preview",
  muted: "",
  playsinline: ""
}
const _hoisted_8 = { class: "camera-footer" }
const _hoisted_9 = {
  "aria-label": "Foto selecteren",
  class: "control-button"
}
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              "aria-label": "Sluiten",
              class: "control-button",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                fill: "none",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M18 6L6 18M6 6L18 18",
                  stroke: "currentColor",
                  "stroke-linecap": "round",
                  "stroke-width": "2"
                })
              ], -1)
            ]))]),
            (_ctx.hasTorch)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  "aria-label": _ctx.torchOn ? 'Lamp uitzetten' : 'Lamp aanzetten',
                  class: _normalizeClass([{'is-active': _ctx.torchOn}, "control-button"]),
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTorch && _ctx.toggleTorch(...args)))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                    _createElementVNode("path", {
                      fill: _ctx.torchOn ? 'currentColor' : 'none',
                      d: "M13 2L4.09347 12.6879C3.74466 13.1064 3.57026 13.3157 3.56759 13.4925C3.56527 13.6461 3.63372 13.7923 3.75324 13.8889C3.89073 14 4.16316 14 4.70802 14H12L11 22L19.9065 11.3121C20.2553 10.8936 20.4297 10.6843 20.4324 10.5075C20.4347 10.3539 20.3663 10.2077 20.2468 10.1111C20.1093 10 19.8368 10 19.292 10H12L13 2Z",
                      stroke: "currentColor",
                      "stroke-linejoin": "round",
                      "stroke-width": "2"
                    }, null, 8, _hoisted_5)
                  ]))
                ], 10, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("video", _hoisted_7, null, 512)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("svg", {
                fill: "fill",
                viewBox: "0 0 32 32",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  d: "M25.3333 9.33342V13.3201C25.3333 13.3201 22.68 13.3334 22.6667 13.3201V9.33342H18.6667C18.6667 9.33342 18.68 6.68008 18.6667 6.66675H22.6667V2.66675H25.3333V6.66675H29.3333V9.33342H25.3333ZM21.3333 14.6667V10.6667H17.3333V6.66675H6.66667C5.2 6.66675 4 7.86675 4 9.33342V25.3334C4 26.8001 5.2 28.0001 6.66667 28.0001H22.6667C24.1333 28.0001 25.3333 26.8001 25.3333 25.3334V14.6667H21.3333ZM6.66667 25.3334L10.6667 20.0001L13.3333 24.0001L17.3333 18.6667L22.6667 25.3334H6.66667Z",
                  fill: "fill"
                })
              ], -1)),
              _createElementVNode("input", {
                accept: "image/*",
                class: "gallery-input",
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGallerySelected && _ctx.onGallerySelected(...args)))
              }, null, 32)
            ]),
            _createElementVNode("button", {
              disabled: _ctx.isCapturing,
              "aria-label": "Foto maken",
              class: "shutter",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.capture && _ctx.capture(...args)))
            }, null, 8, _hoisted_10),
            (_ctx.hasMultipleCameras)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  "aria-label": "Wisselen van camera",
                  class: "control-button",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.flipCamera && _ctx.flipCamera(...args)))
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("svg", {
                    fill: "none",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      d: "M20 5H17L15 3H9L7 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM12 18C9.24 18 7 15.76 7 13H9L6 10L3 13H5C5 16.87 8.13 20 12 20V18ZM12 8C14.76 8 17 10.24 17 13H15L18 16L21 13H19C19 9.13 15.87 6 12 6V8Z",
                      fill: "currentColor"
                    })
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}